var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconArrowRightLineBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.8484 11.4343C16.1608 11.7467 16.1608 12.2533 15.8484 12.5657L11.3229 17.0912C11.0105 17.4036 10.5039 17.4036 10.1915 17.0912C9.8791 16.7787 9.8791 16.2722 10.1915 15.9598L14.1513 12L10.1915 8.0402C9.8791 7.72778 9.8791 7.22125 10.1915 6.90883C10.5039 6.59641 11.0105 6.59641 11.3229 6.90883L15.8484 11.4343Z",
    fill: "#09244B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArrowRightLineBlack);
export default __webpack_public_path__ + "static/media/icon_arrow_right_line_black.ba6e9088eb2c2768110bef757661087f.svg";
export { ForwardRef as ReactComponent };